export const API_URL = process.env.REACT_APP_API_URL;

export const BRAND_GREEN = "#6BC74B";

export class TreatmentTypes {
  static MildCase = "Mild Case";
  static ComplexCase = "Complex Case";
}

export const CASE_STATUS = {
  FOR_DESIGN: "For design",
  FOR_SCANNING: "For scanning ",
};

export const PROGRESSION_TYPE = {
  REVIEW_DESIGN: "Review Design",
};

export const AlinaStatus = [
  "Lead",
  "For online consultation",
  "For F2F consultation",
  "For scanning",
  "Design in progress",
  "For design approval",
  "Design approved",
  "For fabrication",
  "For shipment",
  "Case complete",
  "Terminated",
];

export const TREATMENT_FILES = [
  {
    name: "IOS Scan (STL File)",
    type: 1,
    files: [
      {
        label: "Maxillary",
        name: "iosScan.maxillary",
        subType: 1,
      },
      {
        label: "Mandibular",
        name: "iosScan.mandibular",
        subType: 2,
      },
      {
        label: "Bite Scan",
        name: "iosScan.biteScan",
        subType: 3,
      },
    ],
  },
  {
    name: "Clinical Photography",
    type: 2,
    files: [
      {
        label: "Full Face (Not Smiling)",
        name: "photography.fullFace",
        subType: 1,
      },
      {
        label: "Full Face (Smiling)",
        name: "photography.fullFaceSmiling",
        subType: 2,
      },
      {
        label: "Profile of face (Not Smiling)",
        name: "photography.profile",
        subType: 3,
      },
      {
        label: "Occluded bucal view of anterior",
        name: "photography.occludedAnterior",
        subType: 4,
      },
      {
        label: "Occluded bucal view of right lateral",
        name: "photography.occludedRight",
        subType: 5,
      },
      {
        label: "Occluded bucal view of left lateral",
        name: "photography.occludedLeft",
        subType: 6,
      },
      {
        label: "Occlusal view of upper",
        name: "photography.occlusalUpper",
        subType: 7,
      },
      {
        label: "Occlusal view of lower",
        name: "photography.occlusalLower",
        subType: 8,
      },
    ],
  },
];
